import React, {Component} from 'react'
import TriangleShape from "../types/TriangleShape";
import RenderText from "../render-text";
import {GradientDefs, GradientFillUrl} from "shape-edit/forms/fields";
import {textOverflowResizeLayer} from "app/helpers/other";
import {DEFAULT_LINE_CAP, DEFAULT_LINE_JOIN, LINE_CAP_CONSTS, LINE_JOIN_CONSTS} from "shape-edit/forms/helpers";
import { Size } from 'app/types/model-types';
import { EditModeType } from 'app/types/app-types';

interface Props {
    data: TriangleShape
    turnUpsideDown: boolean
    activeShapeId: string
    updateShape: Function
    editMode: EditModeType
}

interface State {
    newSize: Size
}

class TriangleSvg extends Component<Props, State> {
    constructor(props) {
        super(props)

        this.state = {
            newSize: null,
        }
    }

    setRealSize = (newSize: Size) => {
        //TODO?
    }

    render() {
        const shapeObject : TriangleShape = this.props.data
        const scale = shapeObject.scale && shapeObject.scale !== 0 ? shapeObject.scale : 1
        const coef = this.props.turnUpsideDown ? -1 : 1

        const isShadow = shapeObject.shadow_color && shapeObject.shadow_sigma

        const newSize =  textOverflowResizeLayer(shapeObject)
        const width = newSize.width || shapeObject.width
        const height = newSize.height || shapeObject.height

        const side = width * 0.8660254038
        const points = `${coef*width / 2},${coef*side / 2} ${-(width / 2)},${coef*side / 2} ${0},${-(coef*side / 2)} ${width / 2},${coef*side / 2}`
        const h = Math.round(shapeObject.text_fontsize / scale)

        const offsetY = shapeObject.text_valign === 0 ? coef * (width - side) : coef * (width - side) * (-shapeObject.text_valign || 1)

        return (
            <g className="draggable">
                {isShadow &&
                <filter id={`shadow-${shapeObject.index}`} width="200%" height="200%" y="-50%" x="-50%">
                    <feDropShadow
                        dx={shapeObject.shadow_xoffset}
                        dy={shapeObject.shadow_yoffset}
                        stdDeviation={shapeObject.shadow_sigma}
                        floodColor={shapeObject.shadow_color}
                        floodOpacity={1-shapeObject.shadow_opacity/100}
                    />
                </filter>
                }

                {shapeObject.gradient_id && shapeObject.gradient &&
                <GradientDefs gradient={shapeObject.gradient} idx={shapeObject.gradient_id} />
                }

                <polygon
                    points={points}
                    strokeWidth={shapeObject.stroke_width}
                    stroke={shapeObject.stroke_color}
                    strokeLinejoin={shapeObject.line_join && LINE_JOIN_CONSTS[shapeObject.line_join] ? LINE_JOIN_CONSTS[shapeObject.line_join]: DEFAULT_LINE_JOIN}
                    strokeLinecap={shapeObject.line_cap && LINE_CAP_CONSTS[shapeObject.line_cap] ? LINE_CAP_CONSTS[shapeObject.line_cap]: DEFAULT_LINE_CAP}
                    fill={shapeObject.gradient_id && shapeObject.gradient ? GradientFillUrl(shapeObject.gradient_id) : shapeObject.color}
                    fillOpacity={shapeObject.gradient_id && shapeObject.gradient && shapeObject.gradient.opacity ? shapeObject.gradient.opacity / 100 : 1}
                    filter={isShadow ? `url(#shadow-${shapeObject.index})` : ''}
                />

                <RenderText
                    shape={shapeObject}
                    fontSize={h}
                    width={width}
                    h={height}
                    setRealSize={this.setRealSize}
                    offsetY={offsetY}
                    activeShapeId={this.props.activeShapeId}
                    updateShape={this.props.updateShape}
                    editMode={this.props.editMode}
                />
            </g>
        )
    }
}

export default TriangleSvg
